<template>
    <b-card class="sa-card sa-card-border" header="Interventi psicoeducativi, abilitativi e riabilitativi socio-riabilitativi" header-tag="header" footer-tag="footer" title="">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-row>
                    <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Inizio</label>
                        <date-picker v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                    </b-col>
                    <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Fine</label>
                        <date-picker v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Adesione al protocollo terapeutico-riabilitativo ella vitacomunitaria </label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.protocolloTrVitacomunitaria" :options="sinoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                        <span v-else>{{ jsonData.protocolloTrVitacomunitaria }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" style="">
                        <label class="sa-label-data">Dettaglio:</label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.protocolloTrVitacomunitariaDettaglio" :disabled="isFormDisabled(jsonData.protocolloTrVitacomunitaria)"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Stimolare integrazione e aderenza alle regole della C.T.A. </label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.integrazioneAderenzaCta" :options="sinoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                        <span v-else>{{ jsonData.integrazioneAderenzaCta }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" style="">
                        <label class="sa-label-data">Dettaglio:</label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.integrazioneAderenzaCtaDettaglio" :disabled="isFormDisabled(jsonData.integrazioneAderenzaCta)"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Migliorare le capacità relazionali attraverso l'inserimento in attività scoializzanti</label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.capacitaRelazionare" :options="sinoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                        <span v-else>{{ jsonData.capacitaRelazionare }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" style="">
                        <label class="sa-label-data">Dettaglio:</label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.capacitaRelazionareDettaglio" :disabled="isFormDisabled(jsonData.capacitaRelazionare)"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Facilitare la riscoperta delle abilità attraverso l'esperimento in maniera protetta </label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.riscopertaAbilita" :options="sinoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                        <span v-else>{{ jsonData.riscopertaAbilita }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" style="">
                        <label class="sa-label-data">Dettaglio:</label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.riscopertaAbilitaDettaglio" :disabled="isFormDisabled(jsonData.riscopertaAbilita)"></b-form-input>
                    </b-col>
                    <b-col v-for="(data, index) in jsonData.listaAltroSocioRiabilitativi" :key="'socioRiabilitativo' + index" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Altro</label>
                        <b-form-textarea v-if="!isReadOnly" v-model="jsonData.listaAltroSocioRiabilitativi[index].dettaglio" rows="3" max-rows="6"></b-form-textarea>
                        <span v-else> {{ data.dettaglio }} </span>
                    </b-col>
                    <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 10px">
                        <b-button size="sm" variant="outline-danger outline-primary-noborder sa-margin-right float-sm-right" @click="onClickRimuoviAltroSocioRiabilitativi" class="mb-2" :disabled="jsonData.listaAltroSocioRiabilitativi.length == 1">
                            <i class="fas fa-minus"></i>
                            Rimuovi
                        </b-button>
                        <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungiAltroSocioRiabilitativi" class="mb-2">
                            <i class="fas fa-plus"></i>
                            Aggiungi
                        </b-button>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Partecipazione alle attività riabilitative individuali o di gruppo </label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.partecipazioneAttivita" :options="sinoOptions" :value="''" value-field="value" text-field="text" @change="onChangePartecipazioneAttivita"></b-form-select>
                        <span v-else>{{ jsonData.partecipazioneAttivita }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Cura del sè </label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.curaSe" :options="sinoOptions" :value="''" value-field="value" text-field="text" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-select>
                        <span v-else>{{ jsonData.curaSe }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dettaglio: </label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.curaSeDettaglio" :disabled="isFormDisabled(jsonData.curaSe)"></b-form-input>
                        <span v-else>{{ jsonData.curaSeDettaglio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Progetti per sviluppo autonomie personali</label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.sviluppoAutonomiePersonali" :options="sinoOptions" :value="''" value-field="value" text-field="text" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-select>
                        <span v-else>{{ jsonData.sviluppoAutonomiePersonali }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dettaglio: </label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.sviluppoAutonomiePersonaliDettaglio" :disabled="isFormDisabled(jsonData.sviluppoAutonomiePersonali)"></b-form-input>
                        <span v-else>{{ jsonData.sviluppoAutonomiePersonaliDettaglio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Laboratori cognitivi</label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.laboratoriCognitivi" :options="sinoOptions" :value="''" value-field="value" text-field="text" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-select>
                        <span v-else>{{ jsonData.laboratoriCognitivi }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dettaglio: </label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.laboratoriCognitiviDettaglio" :disabled="isFormDisabled(jsonData.laboratoriCognitivi)"></b-form-input>
                        <span v-else>{{ jsonData.laboratoriCognitiviDettaglio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Laboratori manuali</label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.laboratoriManuali" :options="sinoOptions" :value="''" value-field="value" text-field="text" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-select>
                        <span v-else>{{ jsonData.laboratoriManuali }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dettaglio: </label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.laboratoriManualiDettaglio" :disabled="isFormDisabled(jsonData.laboratoriManuali)"></b-form-input>
                        <span v-else>{{ jsonData.laboratoriManualiDettaglio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Laboraoti emotivi</label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.laboratoriEmotivi" :options="sinoOptions" :value="''" value-field="value" text-field="text" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-select>
                        <span v-else>{{ jsonData.laboratoriEmotivi }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dettaglio: </label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.laboratoriEmotiviDettaglio" :disabled="isFormDisabled(jsonData.laboratoriEmotivi)"></b-form-input>
                        <span v-else>{{ jsonData.laboratoriEmotiviDettaglio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Gruppo Cucina</label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.gruppoCucina" :options="sinoOptions" :value="''" value-field="value" text-field="text" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-select>
                        <span v-else>{{ jsonData.gruppoCucina }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dettaglio: </label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.gruppoCucinaDettaglio" :disabled="isFormDisabled(jsonData.gruppoCucina)"></b-form-input>
                        <span v-else>{{ jsonData.gruppoCucinaDettaglio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Attività Sportive</label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.attivitaSportive" :options="sinoOptions" :value="''" value-field="value" text-field="text" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-select>
                        <span v-else>{{ jsonData.attivitaSportive }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dettaglio: </label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.attivitaSportiveDettaglio" :disabled="isFormDisabled(jsonData.attivitaSportive)"></b-form-input>
                        <span v-else>{{ jsonData.attivitaSportiveDettaglio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Attività esterne</label>
                        <b-form-select v-if="!isReadOnly" v-model="jsonData.attivitaEsterne" :options="sinoOptions" :value="''" value-field="value" text-field="text" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-select>
                        <span v-else>{{ jsonData.attivitaEsterne }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dettaglio: </label>
                        <b-form-input v-if="!isReadOnly" v-model="jsonData.attivitaEsterneDettaglio" :disabled="isFormDisabled(jsonData.attivitaEsterne)"></b-form-input>
                        <span v-else>{{ jsonData.attivitaEsterneDettaglio }}</span>
                    </b-col>
                    <b-col v-for="(data, index) in jsonData.listaAltreAttivita" :key="'attivita' + index" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Altre attività</label>
                        <b-form-textarea v-if="!isReadOnly" v-model="jsonData.listaAltreAttivita[index].dettaglio" rows="3" max-rows="6" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)"></b-form-textarea>
                        <span v-else> {{ data.dettaglio }} </span>
                    </b-col>
                    <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 10px">
                        <b-button size="sm" variant="outline-danger outline-primary-noborder sa-margin-right float-sm-right" @click="onClickRimuoviAltreAttivita" class="mb-2" :disabled="jsonData.listaAltreAttivita.length == 1 && isFormDisabled(jsonData.partecipazioneAttivita)">
                            <i class="fas fa-minus"></i>
                            Rimuovi
                        </b-button>
                        <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungiAltreAttivita" class="mb-2" :disabled="isFormDisabled(jsonData.partecipazioneAttivita)">
                            <i class="fas fa-plus"></i>
                            Aggiungi
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            isPersonaRiferimento: true,
            pathResourche: "/rsapazientesrriabilitativopedagogico",
            cont: 0,
            jsonData: {
                attivitaEsterne: "",
                attivitaEsterneDettaglio: "",
                attivitaSportive: "",
                attivitaSportiveDettaglio: "",
                capacitaRelazionare: "",
                capacitaRelazionareDettaglio: "",
                curaSe: "",
                curaSeDettaglio: "",
                gruppoCucina: "",
                gruppoCucinaDettaglio: "",
                id: null,
                integrazioneAderenzaCta: "",
                integrazioneAderenzaCtaDettaglio: "",
                laboratoriCognitivi: "",
                laboratoriCognitiviDettaglio: "",
                laboratoriManuali: "",
                laboratoriManualiDettaglio: "",
                partecipazioneAttivita: "",
                proprietario: "",
                protocolloTrVitacomunitaria: "",
                protocolloTrVitacomunitariaDettaglio: "",
                riscopertaAbilita: "",
                riscopertaAbilitaDettaglio: "",
                laboratoriEmotivi: "",
                laboratoriEmotiviDettaglio: "",
                sviluppoAutonomiePersonali: "",
                sviluppoAutonomiePersonaliDettaglio: "",
                listaAltroSocioRiabilitativi: [{ dettaglio: "" }],
                listaAltreAttivita: [{ dettaglio: "" }],
            },
            params: "",
            nomeProgetto: "PROGETTO RIABILITATIVO PEDAGOGICO",
            sinoOptions: [
                { text: "- Selezionare Valore -", value: "" },
                { text: "SI", value: "SI" },
                { text: "NO", value: "NO" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { progettoRiabilitativoPedagogico: "SI" };
        me.params = JSON.stringify(params);
        me.jsonData = {
            idAccettazione: me.idAccettazione,
            params: me.params,
            nomeProgetto: "PROGETTO RIABILITATIVO PEDAGOGICO",
            dataInizio: new Date().getTime(),
            dataFine: null,
            attivitaEsterne: "",
            attivitaEsterneDettaglio: "",
            attivitaSportive: "",
            attivitaSportiveDettaglio: "",
            capacitaRelazionare: "",
            capacitaRelazionareDettaglio: "",
            curaSe: "",
            curaSeDettaglio: "",
            gruppoCucina: "",
            gruppoCucinaDettaglio: "",
            id: null,
            integrazioneAderenzaCta: "",
            integrazioneAderenzaCtaDettaglio: "",
            laboratoriCognitivi: "",
            laboratoriCognitiviDettaglio: "",
            laboratoriManuali: "",
            laboratoriManualiDettaglio: "",
            partecipazioneAttivita: "",
            proprietario: "",
            protocolloTrVitacomunitaria: "",
            protocolloTrVitacomunitariaDettaglio: "",
            riscopertaAbilita: "",
            riscopertaAbilitaDettaglio: "",
            laboratoriEmotivi: "",
            laboratoriEmotiviDettaglio: "",
            sviluppoAutonomiePersonali: "",
            sviluppoAutonomiePersonaliDettaglio: "",
            listaAltroSocioRiabilitativi: [{ dettaglio: "" }],
            listaAltreAttivita: [{ dettaglio: "" }],
        };
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourche + "/" + me.idRisorsa, {}, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        resultErrorData(error) {
            console.log(error.response.data.messaggio);
        },
        onClickAggiungiAltroSocioRiabilitativi() {
            let me = this;
            me.jsonData.listaAltroSocioRiabilitativi.push({ dettaglio: null });
        },
        onClickRimuoviAltroSocioRiabilitativi() {
            let me = this;
            if (me.jsonData.listaAltroSocioRiabilitativi.length > 1) {
                me.jsonData.listaAltroSocioRiabilitativi.pop();
            }
        },
        onClickAggiungiAltreAttivita() {
            let me = this;
            me.jsonData.listaAltreAttivita.push({ dettaglio: null });
        },
        onClickRimuoviAltreAttivita() {
            let me = this;
            if (me.jsonData.listaAltreAttivita.length > 1) {
                me.jsonData.listaAltreAttivita.pop();
            }
        },
        isFormDisabled(value) {
            return value !== "SI";
        },
        onChangePartecipazioneAttivita(value) {
            let me = this;
            me.jsonData.curaSe = value !== "NO" ? "" : "NO";
            me.jsonData.sviluppoAutonomiePersonali = value !== "NO" ? "" : "NO";
            me.jsonData.laboratoriCognitivi = value !== "NO" ? "" : "NO";
            me.jsonData.laboratoriEmotivi = value !== "NO" ? "" : "NO";
            me.jsonData.laboratoriManuali = value !== "NO" ? "" : "NO";
            me.jsonData.gruppoCucina = value !== "NO" ? "" : "NO";
            me.jsonData.attivitaSportive = value !== "NO" ? "" : "NO";
            me.jsonData.attivitaEsterne = value !== "NO" ? "" : "NO";
        },
    },
};
</script>
